module.exports = __webpack_public_path__ + "img/P13.7d30f6cc.png";